
define('text!modules/base/templates/following.template.html',[],function () { return '<div class="followingIcon relpro-sk follow">\r\n\r\n</div>&nbsp;&nbsp;\r\n<div class="followingTxt">Follow</div>';});

